import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useCollapsibleSectionsContext } from '~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider';
import { CollapsibleSection } from '~/components/AssetModalV2/InfoPanel/components/CollapsibleSection';
import { SectionDisplay } from '~/components/AssetModalV2/InfoPanel/components/SectionDisplay';
import { PublicTagsList } from '~/components/AssetModalV2/InfoPanel/PublicTagsList';
import { centralizedClipDescriptionSelector, centralizedClipTagsSelector } from '~/store/centralizedClip/selectors';

export const PublicCustomMetadataCollapsibleSection = memo(() => {
  const description = useSelector(centralizedClipDescriptionSelector);
  const tags = useSelector(centralizedClipTagsSelector);
  const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
  const isExpanded = expandedSections.customMetadata;
  const onOpenChange = useCallback(() => {
    toggleSection('customMetadata');
  }, [toggleSection]);

  if (!description && !tags?.length) {
    return null;
  }

  return (
    <CollapsibleSection
      title="Custom metadata"
      isExpanded={isExpanded}
      onOpenChange={onOpenChange}
      data-testid="CUSTOM_METADATA_SECTION"
    >
      <div className="flex flex-col gap-4 pt-2">
        {!!description && (
          <SectionDisplay title="Description" data-testid="CUSTOM_METADATA_INFO_PANEL_DESCRIPTION">
            <div
              className="ads:text-secondary text-12 text-gray-11"
              data-testid="CUSTOM_METADATA_INFO_PANEL_DESCRIPTION_TEXT"
            >
              {description}
            </div>
          </SectionDisplay>
        )}
        <PublicTagsList tags={tags} />
      </div>
    </CollapsibleSection>
  );
});

PublicCustomMetadataCollapsibleSection.displayName = 'PublicCustomMetadataCollapsibleSection';
